/*
 * Tabs script
 */
class MC_MoreText {
    constructor() {
        this.initState();
    }

    initState() {
        this.moreTexts = $('a.readmore_text');
        if (this.moreTexts.length > 0) {
            this.initMoreTextsEvents();
        }
    }

    initMoreTextsEvents() {
        this.moreTexts.on('click', function(e){
            e.preventDefault();
            let moreContent = $(this).parent().find('.more-text');
            if(moreContent.length > 0){
               moreContent.each(function(){
                   if($(this).hasClass('active')){
                       $(this).removeClass('active');
                   }
                   else{
                       $(this).addClass('active');
                   }
               });
            }
        });
    }
}
